import * as Yup from "yup";
import CMSSchema from "./cms";
import ContactUsSchema from "./contactUsSchema";
import FAQSchema from "./faqSchema";


const localPlanSettingsSchema = Yup.object().shape({
  local: Yup.string().required("Required")
});

const multiversePlanSettingsSchema = Yup.object().shape({
  multiverse: Yup.string().required("Required")
});

const planDetailsSchema = Yup.object().shape({
  network: Yup.string().required("Required"),
  planType: Yup.string().required("Required"),
  otherInfo: Yup.string().required("Required"),
  activationPolicy: Yup.string().required("Required"),
});
const InstaSchema = Yup.object().shape({
  url: Yup.string().url("Invalid URL").required("URL is required"),
});

const BlogSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  // author: Yup.string().required("Author is required"),
  content: Yup.string().url("Invalid URL").required("URL is required"),
  readTime: Yup.string().required("Read Time is required"),
  slug: Yup.string().required("Slug is required"),
});

export {
  localPlanSettingsSchema,
  multiversePlanSettingsSchema,
  planDetailsSchema,
  CMSSchema,
	ContactUsSchema,
	FAQSchema,
	InstaSchema,
  BlogSchema
};